import { getNatureNamesByValues } from '../../../caracteristiques/services/natures.enum';

export default class ImageDetailController {
    static $inject = ['$stateParams', '$state', 'ImagesService', 'notification', 'ImagesCommunicationService'];

    constructor($stateParams, $state, ImagesService, notification, ImagesCommunicationService) {
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.ImagesService = ImagesService;
        this.notification = notification;
        this.ImagesCommunicationService = ImagesCommunicationService;
    }

    $onInit() {
        this.loading = false;
        this.image = {};
        this.caracteristiques = [];

        this.ongletOpen = {
            isEnteteOpen: true,
            isCaracteristiqueOpen: false
        };

        this.initImage();
    }

    async initImage() {
        this.image = { id: this.$stateParams.id };
        if (this.image.id) {
            this.startLoading();
            try {
                this.image.entete = await this.ImagesService.getImageEnteteById(this.image.id);
                this.image.caracteristiques = await this.ImagesService.getImageValeursCaracteristiquesById(this.image.id);
                this.setCaracteristiques(this.image.caracteristiques);
            } catch (ex) {
                if (ex.status === 404) {
                    this.goListImage();
                }
                this.notification.error(ex.data);
            } finally {
                this.stopLoading();
            }
        } else {
            this.goListImage();
        }
    }

    async getImageEntete(imageId) {
        this.image.entete = await this.ImagesService.getImageEnteteById(imageId);
    }

    async setCaracteristiques(caracteristiques = []) {
        const natures = getNatureNamesByValues();
        this.caracteristiques = [];
        caracteristiques.forEach((c) => {
            this.caracteristiques.push({
                code: c.code,
                label: c.label,
                values: getValue(c.value),
                nature: natures[c.idNature],
                numericAdditionalInformation: c.numericAdditionalInformation,
                labelCls: 'col-xs-12 col-sm-4',
                inputCls: 'col-xs-12 col-sm-8'
            });
        });

        function getValue(val) {
            if (angular.isArray(val)) {
                if (_.some(val, 'key')) {
                    return _.map(val, 'value');
                }
                return val;
            }
            return [val];
        }
    }

    goListImage() {
        this.$state.go('images.list', {}, { reload: true });
    }

    startLoading() {
        this.loading = true;
    }

    stopLoading() {
        this.loading = false;
    }
}
